export const TOGGLE_RESERVATION = 'TOGGLE_RESERVATION';
export const FETCH_ROCKETS = 'FETCH_ROCKETS';
export const FETCH_ROCKETS_FAILURE = 'FETCH_ROCKETS_FAILURE';
